import { useState, useRef, useEffect } from "react";
import { API } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { PaperPlaneRight, Robot } from "@phosphor-icons/react";

export default function NIC() {
  const [msgs, setMsgs] = useState([{ role: "assistant", text: "Hallo! Ich bin NIC, dein virtueller Assistent von MainSpessartBlick. Wie kann ich dir helfen?" }]);
  const [input, setInput] = useState("");
  const [streaming, setStreaming] = useState(false);
  const [sid] = useState(() => crypto.randomUUID());
  const bottomRef = useRef(null);

  useEffect(() => { bottomRef.current?.scrollIntoView({ behavior: "smooth" }); }, [msgs]);

  const send = async () => {
    if (!input.trim() || streaming) return;
    const userMsg = input;
    setMsgs(m => [...m, { role: "user", text: userMsg }, { role: "assistant", text: "" }]);
    setInput(""); setStreaming(true);
    try {
      const resp = await fetch(`${API}/nic/chat`, {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ message: userMsg, session_id: sid }),
      });
      const reader = resp.body.getReader();
      const dec = new TextDecoder();
      let buffer = "";
      while (true) {
        const { done, value } = await reader.read();
        if (done) break;
        buffer += dec.decode(value, { stream: true });
        const events = buffer.split("\n\n");
        buffer = events.pop() || "";
        for (const ev of events) {
          const line = ev.trim();
          if (!line.startsWith("data: ")) continue;
          const data = line.slice(6);
          if (data === "[DONE]") continue;
          setMsgs(m => {
            const copy = [...m];
            copy[copy.length - 1] = { role: "assistant", text: copy[copy.length - 1].text + data };
            return copy;
          });
        }
      }
    } catch (e) {
      setMsgs(m => {
        const copy = [...m];
        copy[copy.length - 1] = { role: "assistant", text: "Es ist ein Fehler aufgetreten." };
        return copy;
      });
    } finally { setStreaming(false); }
  };

  return (
    <div className="space-y-4 max-w-3xl mx-auto" data-testid="nic-page">
      <div className="flex items-center gap-3">
        <div className="w-12 h-12 rounded-2xl bg-primary flex items-center justify-center">
          <Robot size={24} weight="duotone" color="white"/>
        </div>
        <div>
          <h1 className="text-3xl font-bold" style={{fontFamily:"'Work Sans',sans-serif"}}>NIC</h1>
          <p className="text-muted-foreground text-sm">Ihr KI-Assistent für Fragen und Textentwürfe</p>
        </div>
      </div>

      <div className="msb-card min-h-[500px] flex flex-col gap-3 p-4">
        <div className="flex-1 space-y-3 overflow-y-auto max-h-[60vh]">
          {msgs.map((m, i) => (
            <div key={i} className={`flex ${m.role==="user"?"justify-end":"justify-start"}`}>
              <div className={`max-w-[80%] rounded-2xl px-4 py-2.5 text-sm ${m.role==="user" ? "bg-primary text-white" : "bg-muted"}`}>
                {m.text || <span className="opacity-50">…</span>}
              </div>
            </div>
          ))}
          <div ref={bottomRef}/>
        </div>
        <div className="flex gap-2">
          <Input
            data-testid="nic-input"
            value={input} onChange={e=>setInput(e.target.value)}
            onKeyDown={e=>e.key==="Enter" && send()}
            placeholder="Frage NIC etwas…" className="rounded-xl"
            disabled={streaming}
          />
          <Button onClick={send} disabled={streaming} className="rounded-xl bg-primary" data-testid="nic-send-btn">
            <PaperPlaneRight size={16} weight="bold"/>
          </Button>
        </div>
      </div>
    </div>
  );
}
